import { p2 } from "../assets";
import styles from "../style";
import { Reveal } from "./reveal";


const Mission = () => (  
  <div className={`py-20 w-full`}>
    <div className={`flex-col gap-10 px-6`}>
      <div className="flex flex-col py-10 justify-between items-center w-full">
        <Reveal>
          <h1 className="kerning-normal pb-10 text-center text-white font-semibold text-md leading-[30px] xs:leading-[50px] xs:max-w-[640px] max-w-[400px]">
            Who We Are?
          </h1>
        </Reveal>
        <Reveal>
          <p className={`kerning-normal xs:text-sm text-ss text-tertiary xs:max-w-[640px] max-w-[360px] mt-5 text-center`}>
            We are resourcing the next generation of disruptive, African led, tech enabled startups and creator led ventures. Founded on an us for us mindset, we are pooling resources to make our mission of local capital for local brilliance possible.
          </p>
        </Reveal>
      </div>
      <div className={`flex-col gap-10 w-full py-10`}>
        <div className={`${styles.flexStart} flex-row`}>
          <div className="flex flex-col gap-2 xs:w-[300px] xs:h-[300px] w-[200px] h-[200px] p-8 items-end justify-center bg-second">     
            <Reveal>
              <h2 className="kerning-normal xs:text-mm text-sm text-white font-semibold">
                Our Purpose
              </h2>
            </Reveal>
            <span className="border-b border-2 border-third w-[100px]"></span>
            <Reveal>
              <p className={`kerning-normal xs:text-sm text-ss text-white max-w-[160px] mt-5 text-right`}>
                To catalyze Africas innovation economy by backing visionary founders.
              </p>
            </Reveal>
          </div>
          <img 
            src={p2}
            alt="Our Purpose"
            className="xs:w-[300px] xs:h-[300px] w-[200px] h-[200px] object-cover" 
          />
        </div>

        <div className={`${styles.flexStart} flex-row`}>
          <img 
            src={p2}
            alt="Our Purpose"
            className="xs:w-[300px] xs:h-[300px] w-[200px] h-[200px] object-cover" 
          />
          <div className="flex flex-col gap-2 xs:w-[300px] xs:h-[300px] w-[200px] h-[200px] p-8 items-start justify-center bg-second">     
            <Reveal>
              <h2 className="kerning-normal xs:text-mm text-sm text-white font-semibold">
                Our Mission
              </h2>
            </Reveal>
            <span className="border-b border-2 border-third w-[100px]"></span>
            <Reveal>
              <p className={`kerning-normal xs:text-sm text-ss text-white max-w-[160px] mt-5 text-left`}>
                To catalyze Africas innovation economy by backing visionary founders.
              </p>
            </Reveal>
          </div>
        </div>

        <div className={`${styles.flexStart} flex-row`}>
          <div className="flex flex-col gap-2 xs:w-[300px] xs:h-[300px] w-[200px] h-[200px] p-8 items-end justify-center bg-second">     
            <Reveal>
              <h2 className="kerning-normal xs:text-mm text-sm text-white font-semibold">
                Our Vision
              </h2>
            </Reveal>
            <span className="border-b border-2 border-third w-[100px]"></span>
            <Reveal>
              <p className={`kerning-normal xs:text-sm text-ss text-white max-w-[160px] mt-5 text-right`}>
                To catalyze Africas innovation economy by backing visionary founders.
              </p>
            </Reveal>
          </div>
          <img 
              src={p2}
              alt="Our Purpose"
              className="xs:w-[300px] xs:h-[300px] w-[200px] h-[200px] object-cover" 
            />
        </div>
      </div>    
    </div>
  </div>
);

export default Mission;
